import React from "react";
import { useLocation } from "react-router-dom";
import { useGetNotificationsQuery } from "../../redux/slices/api/userApi";
import { useSelector } from "react-redux";
import  { selectGeneral } from "../../redux/slices/generalSlice";
const NewNotifIcon = ({
  className = "absolute -left-0.5 -bottom-0.5 w-3.5 h-3.5",
}) => {
  const location = useLocation();
  const { isLoggedIn } = useSelector(selectGeneral);
  const isAdminPage = location.pathname.startsWith("/admin");
  
  // Skip fetching on admin pages or when not logged in
  const { data: notifData, isLoading: notifLoading } = useGetNotificationsQuery(
    undefined,
    { skip: !isLoggedIn || isAdminPage }
  );

  if (!notifLoading && notifData?.filter((item) => !item?.seen)?.length > 0) {
    return <span className={` rounded-full bg-primary ${className}`}></span>;
  } else return null;
};

export default NewNotifIcon;
